<!-- <p>loading-dashboard-dialog works!</p> -->

<div *ngIf="!data.isFailed">
  <h1 mat-dialog-title>Loading Dashboard</h1>
  <mat-dialog-content class="mat-typography">
    <div class="add-user-dialog-status">
      <i>Please wait while Fetching Data!</i>
      <mat-spinner></mat-spinner>
      <mat-divider></mat-divider>
    </div>
  </mat-dialog-content>
</div>

<div *ngIf="data.isFailed">
  <h1 mat-dialog-title>Loading Dashboard Failed</h1>
  <mat-dialog-content class="mat-typography">
    <div class="add-user-dialog-status">
      <i>Error occurred while Fetching Data!</i>
      <mat-divider></mat-divider>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button [mat-dialog-close]="true" (click)="onReload()">
      Re-Try
    </button>
  </mat-dialog-actions>
</div>
